import { rest } from 'msw';

import { getApiHost } from '@hotjar/common';

import customers from './fixtures/get-customers.json';
import { registerMock } from './registerMock';

const checkoutGetCustomers = rest.get(
  `${getApiHost()}/api/checkout/customers/:accountId`,
  (req, res, ctx) => {
    const accountId = Number(req.params.accountId);
    const responseData = {
      ...customers,
      identifier: accountId,
      hotjar_account_id: accountId,
    };

    return res(ctx.status(200), ctx.json(responseData));
  },
);

registerMock('checkoutGetCustomers', checkoutGetCustomers);

const checkoutGetCustomersPaymentOverdue = rest.get(
  `${getApiHost()}/api/checkout/customers/:accountId`,
  (req, res, ctx) => {
    const accountId = Number(req.params.accountId);
    const responseData = {
      ...customers,
      identifier: accountId,
      hotjar_account_id: accountId,
      subscription: {
        ...customers.subscription,
        status: 'OVERDUE',
      },
    };

    return res(ctx.status(200), ctx.json(responseData));
  },
);

registerMock('checkoutGetCustomersPaymentOverdue', checkoutGetCustomersPaymentOverdue);
